<template>
  <v-app id="inspire">
    <template v-if="!$route.meta.allowAnonymous">
        <v-content>
          <router-view></router-view>
        </v-content>
    </template>
    <template v-else>
        <navigation :toggle="drawer"/>
        <toolbar @toggleNavigationBar="drawer = !drawer" :name="$route.meta.name" />
        <v-content>
           <router-view/>
        </v-content>
          <v-footer class="indigo darken-1" app >
            <span class="white--text">&copy; {{ year() }}</span>
          </v-footer>
    </template>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'App',
  data: () => ({
    drawer: false
  }),
  beforeMount () {
  },
  methods: {
    ...mapActions(['getUrlServices']),
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
}
// iisexpress-proxy 3000 to 3024
/*
poner 4 card 2 para (asignados y finalizado) para mesa ayuda equipo y atenciones
*/
</script>
